<template>
  <v-container
    id="search"
    grid-list-xl
    text-center
    role="search"
    aria-label="Search Section"
  >
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md12
        lg12
      >
        <v-card>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="search"
                  append-icon="fal fa-search"
                  color="accent"
                  :v-validate="`required|min:1|max:${limit}`"
                  :data-vv-as="`${subject.toLowerCase()} search`"
                  data-vv-name="search"
                  :error-messages="errors.collect('search')"
                  :label="$t(`components.${subject.toLowerCase().replace(' ', '_')}.search`) + ' *'"
                  name="search"
                  type="search"
                  aria-label="Search"
                  aria-required="true"
                  :aria-invalid="errors.has('search')"
                  autocomplete="off"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
    name: "Search",
    components: {
        // eslint-disable-next-line vue/no-unused-components
        ValidationProvider
    },
    inject: ["$validator"],
    props: {
        subject: {
            type: String,
            default: ''
        },
        limit: {
            type: Number,
            default: 100
        }
    },
    emits: {'onChangedText': null},
    data() {
        return {
            search: "",
        }
    },
    watch: {
        search(value) {
            this.$emit('onChangedText', value)
        }
    },
}
</script>
